const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  size: state => state.app.size,
  language: state => state.app.language,
  theme: state => state.app.theme,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.nickname,
  username: state => state.user.username,
  role: state => state.user.role,
  orgName: state => state.user.orgName,
  permissions: state => state.user.permissions,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  routes: state => state.permission.routes,
  addRoutes: state => state.permission.addRoutes,
  menuList: state => state.permission.menuList,
  userId: state => state.user.id
}

export default getters